<template #default>
  <div style="display: flex; gap: 4px">
    <a-button type="link" size="small" @click="onEdit">{{
      props.params.editButton ?? 'Edit'
    }}</a-button>
    <a-tooltip
      v-if="props.params.deleteButton"
      :title="deleteDisabled ? deleteDisabledTitle : ''"
    >
      <a-button
        type="link"
        size="small"
        :disabled="deleteDisabled"
        @click="onDelete"
        >Delete</a-button
      >
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
const props = defineProps(['params'])
// const emit = defineEmits(['edit'])

const rowData = () => props.params.node?.data || props.params.data

const deleteDisabled = computed(() => {
  const disabled = props.params.deleteDisabled
  if (typeof disabled === 'function') {
    return !!disabled({ data: rowData() })
  }
  return !!disabled
})

const deleteDisabledTitle = computed(
  () => props.params.deleteDisabledTitle ?? ''
)

const onEdit = () => {
  // emit('edit', props.params.data)
  const showEditModal = props.params.showEditModal
  showEditModal({ data: rowData() })
}

const onDelete = () => {
  const onDelete = props.params.onDelete
  onDelete({ data: props.params.data })
}

// beforeMount(() => {})
</script>
